import React, { useState } from "react";
import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  MenuItem,
  IconButton,
} from "@mui/material";
import {
  HealthAndSafety,
  Watch,
  FitnessCenter,
  LocalDining,
  Pool,
  SelfImprovement,
  Biotech,
  Looks,
  MonitorHeart,
  Diversity3,
  MedicalInformation,
  HealthAndSafetyOutlined,
  SafetyCheck,
} from "@mui/icons-material";
import styles from "./AddBenefitModalStyles";

interface AddBenefitModalProps {
  open: boolean;
  handleClose: () => void;
  onAddBenefit: (benefit: {
    benefit_name: string;
    benefit_type: string;
    description: string;
  }) => void;
}

const benefitTypes = [
  // New categories added at the top
  { type: "SDoH", icon: <Diversity3 /> },
  { type: "Health", icon: <MedicalInformation /> },
  { type: "DVH", icon: <HealthAndSafetyOutlined /> },
  { type: "Safety", icon: <SafetyCheck /> },
  // Existing categories
  { type: "Insurance", icon: <HealthAndSafety /> },
  { type: "Wearable", icon: <Watch /> },
  { type: "Lesson", icon: <FitnessCenter /> },
  { type: "Diet", icon: <LocalDining /> },
  { type: "Gym", icon: <FitnessCenter /> },
  { type: "Analysis", icon: <Biotech /> },
  { type: "Styling", icon: <Looks /> },
  { type: "Monitoring", icon: <MonitorHeart /> },
];

const AddBenefitModal: React.FC<AddBenefitModalProps> = ({
  open,
  handleClose,
  onAddBenefit,
}) => {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    onAddBenefit({ benefit_name: name, benefit_type: type, description });
    setName("");
    setType("");
    setDescription("");
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={styles.modal}>
        <Typography variant="h6" sx={styles.title}>
          Add New Benefit
        </Typography>
        <TextField
          label="Benefit Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          sx={styles.textField}
        />
        <TextField
          label="Category"
          value={type}
          onChange={(e) => setType(e.target.value)}
          select
          fullWidth
          sx={styles.textField}
        >
          {benefitTypes.map((option) => (
            <MenuItem key={option.type} value={option.type}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton size="small" sx={{ mr: 1, color: "#5958e1" }}>
                  {option.icon}
                </IconButton>
                {option.type}
              </Box>
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={4}
          fullWidth
          sx={styles.textField}
        />
        <Box sx={styles.buttons}>
          <Button onClick={handleClose} sx={styles.cancelButton}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={styles.addButton}
          >
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddBenefitModal;
